import BaseStep from './BaseStep.js';

export default class ManageSteps extends BaseStep {
    _init() {
        this._MultiStepForms.Hook.addAction('addEvents', () => {
            this.#nextStepHandler();
            this.#previousStepHandler();
        });

		this._MultiStepForms.Hook.addAction('init', () => {
			this._MultiStepForms.formWrapper.style.setProperty('--steps', this._MultiStepForms.formSteps.length - 1)
			this._MultiStepForms.formSteps.forEach((step, index) => {
				step.style.setProperty(`--step`, index + 1 );
			})
		})
    }

    #nextStepHandler() {
        this._MultiStepForms.handleEvent('keypress', 'form', (event, form) => {
            if (event.key === 'Enter' && !event.target.matches('select,textarea,input[type="file"]')) {
                event.preventDefault();

                if (!this._MultiStepForms.element(event.target, 'input[type="search"]')) {
                    form?.querySelector('.submit-form')?.click();
                }
            }
        });

        this._MultiStepForms.handleEvent('click', '.form-header .breadcrumbs .breadcrumb-label', (event, breadcrumb) => {
            event.preventDefault();

            if (!breadcrumb?.dataset?.step) return;

            const step = parseInt(breadcrumb.dataset.step);

            this.goToStep(step);
        });

        this._MultiStepForms.handleEvent('click', '.submit-form', (event, button) => {

            event.preventDefault();

            const form = button.closest('form');

            this._MultiStepForms.clearErrors();

            const isValid = this._MultiStepForms.validateFields(form);
            // const isValid = true;

            if (!isValid) return;

            let formAction = form.querySelector('input[name="action"]')?.value || '';

            const formId = form?.dataset?.formId || null;

            let canSubmit = formAction !== '';
            if (formId) {
                const forms = this._MultiStepForms.formWrapper.querySelectorAll(`form[data-form-id="${formId}"]`);

                const lastForm = forms[forms.length - 1];

                canSubmit = form === lastForm;

				if (form.querySelector('.is-edit')){
					canSubmit = false;

					this._MultiStepForms.error(null, 'Please confirm changes before submitting.', form);
					return;
				}

                if (canSubmit) {
                    this.#addFieldsIntoLastForm(forms, lastForm);
                }

                this._MultiStepForms.Hook.doAction('identFormsSubmit', form, formAction, forms);
            }
            formAction = form.querySelector('input[name="action"]')?.value || '';
            const sendSubmitRequest = this._MultiStepForms.Hook.applyFilters('sendSubmitRequest', formAction !== '' && canSubmit, form, formAction);

            if (canSubmit) {
				if (!sendSubmitRequest) return;

				this._MultiStepForms.Hook.doAction('beforeSubmitRequestSent', sendSubmitRequest, form, formAction)

                this._MultiStepForms.submitForm(form, formAction)
                    .then((response) => {
                        this._MultiStepForms.Hook.doAction('submitFormSuccess', response, form, formAction);
                        this.nextStep();
                    })
                    .catch((response) => {
                        this._MultiStepForms.Hook.doAction('submitFormFail', response, form, formAction);
						if (response) {
							if (response?.message) {
								let field = response?.field || null;
								let fields = []
								if (field) {
									fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[name="${field}"],select[name="${field}"],textarea[name="${field}"]`);

									if (!field) {
										fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[data-uid="${field}"],select[data-uid="${field}"],textarea[data-uid="${field}"]`);
									}
								}

								if (fields.length){
									fields.forEach((field, index) => {
										this._MultiStepForms.error(field, index === 0 ? response.message : '', null)
									})
								}
								this._MultiStepForms.error(null, response.message, form)

								this._MultiStepForms.error(field, response.message, form)
							} else if (response?.messages && Array.isArray(response?.messages)) {
								for (const index in response.messages) {
									const message = response.messages[index];
									let field = null;
									if (response.fields) {
										field = response.fields[index] || null;
									}

									let fields = []
									if (field) {
										fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[name="${field}"],select[name="${field}"],textarea[name="${field}"]`);

										if (!field) {
											fields = this._MultiStepForms.formWrapper.querySelectorAll(`input[data-uid="${field}"],select[data-uid="${field}"],textarea[data-uid="${field}"]`);
										}
									}

									if (fields.length){
										fields.forEach((field, index) => {
											this._MultiStepForms.error(field, index === 0 ? message : '', null)
										})
									}

									this._MultiStepForms.error(null, message, form)
								}
							}
						} else {
							this._MultiStepForms.error(null, 'Something went wrong.', form)
						}
                    })
                    .finally(() => {
                        this._MultiStepForms.Hook.doAction('submitFormAfterSubmit', form, formAction);
                    });
            } else {
                this.nextStep();
            }
        });
    }

    #previousStepHandler() {
        this._MultiStepForms.handleEvent('click', '.button-prev-step', (event, button) => {
            event.preventDefault();
            this.prevStep();
        })
    }

    nextStep() {
        const currentStep = this._MultiStepForms.currentStep;
        const nextStep = this._MultiStepForms.currentStep + 1;

        const doNextStep = this._MultiStepForms.Hook.applyFilters('doNextStep', true, currentStep, nextStep);

        if (!doNextStep) return;

        const currentFormWrapper = this._MultiStepForms.formSteps[currentStep - 1] || null;
        const nextFormWrapper = this._MultiStepForms.formSteps[currentStep] || null;
        const next2FormWrapper = this._MultiStepForms.formSteps[currentStep + 1] || null;

        if (!currentFormWrapper || !nextFormWrapper) return;

		this._MultiStepForms.formSteps.forEach(f => {
			f.classList.remove('current-step', 'next-step', 'prev-step');
		});

		next2FormWrapper?.classList.add('next-step');
		nextFormWrapper?.classList.add('next-step');
		currentFormWrapper?.classList.add('prev-step');

		this._MultiStepForms.Hook.doAction('nextStep', currentStep, nextStep, currentFormWrapper, nextFormWrapper);

		setTimeout(() => {
			nextFormWrapper?.classList.add('current-step');
			nextFormWrapper?.classList.remove('next-step');
		}, 10)

		nextFormWrapper.style.display = '';
		setTimeout(() => {
			currentFormWrapper.style.display = 'none';
		}, 300)

        this._MultiStepForms.prevStep = currentStep;

        this._MultiStepForms.currentStep ++;

		window.scrollTo(0,0);
    }

    prevStep() {
        const currentStep = this._MultiStepForms.currentStep;
        const prevStep = this._MultiStepForms.currentStep - 1;

		const currentFormWrapper = this._MultiStepForms.formSteps[currentStep - 1] || null;
        const prevFormWrapper = this._MultiStepForms.formSteps[prevStep - 1] || null;
        const prev2FormWrapper = this._MultiStepForms.formSteps[prevStep - 2] || null;

        if (!currentFormWrapper || !prevFormWrapper) return;

		this._MultiStepForms.Hook.doAction('prevStep', currentStep, prevStep, currentFormWrapper, prevFormWrapper);

		const doPrevStep = this._MultiStepForms.Hook.applyFilters('doPrevStep', true, currentStep, prevStep);

		if (!doPrevStep) return;

		this._MultiStepForms.formSteps.forEach(f => {
			f.classList.remove('current-step', 'next-step', 'prev-step');
		});

		currentFormWrapper?.classList.add('next-step');
		prev2FormWrapper?.classList.add('prev-step');
		prevFormWrapper?.classList.add('prev-step');

		setTimeout(() => {
			prevFormWrapper?.classList.add('current-step');
			prevFormWrapper?.classList.remove('prev-step');
		}, 10)

		prevFormWrapper.style.display = '';
		setTimeout(() => {
			currentFormWrapper.style.display = 'none';
		}, 300)

        this._MultiStepForms.prevStep = currentStep;

        this._MultiStepForms.currentStep --;
    }

    goToStep(step) {
        const currentStep = this._MultiStepForms.currentStep;

        const currentFormWrapper = this._MultiStepForms.formSteps[currentStep - 1] || null;
        const nextFormWrapper = this._MultiStepForms.formSteps[step - 1] || null;

        if (!currentFormWrapper || !nextFormWrapper) return;

        currentFormWrapper.style.display = 'none';
        nextFormWrapper.style.display = '';

        this._MultiStepForms.Hook.doAction('goToStep', currentStep, step, currentFormWrapper, nextFormWrapper);

        this._MultiStepForms.prevStep = currentStep;

        this._MultiStepForms.currentStep = step;
    }

    #addFieldsIntoLastForm(forms, to) {
        to.querySelector('.hidden-fields')?.remove();

        const hiddenFieldsContainer = document.createElement('div');
        hiddenFieldsContainer.classList.add('hidden-fields');

        hiddenFieldsContainer.setAttribute('style', 'display:none!important;visibility:hidden!important;opacity:0!important;z-index:-99999999!important')

        for (const form of forms) {

            if (form === to || [...forms].indexOf(form) > [...forms].indexOf(to)) continue;

            const fields = form.querySelectorAll('input,textarea,select');

            for (const field of fields) {
                if (hiddenFieldsContainer.querySelector(`[name="${field.name}"]`) || to.querySelector(`[name="${field.name}"]`)) continue;

                if (field.closest('.choices')){
					if (field.name === 'search_terms') continue;

					if (field.nodeName === 'SELECT' && field.options) {
						Array.from(field.options).forEach(option => {
							if (option.selected) {
								const input = document.createElement('input');
								input.name = field.name;
								input.setAttribute('readonly', true);
								input.value = option.value;

								hiddenFieldsContainer.append(input);
							}
						});
					}
                } else {
					let input;
					if (field.nodeName === 'SELECT' || (field.nodeName === 'INPUT' && ['radio', 'checkbox'].includes(field.type)) ) {
						input = document.createElement('input');
						input.type = 'text';
					} else {
						input = document.createElement(field.nodeName.toLowerCase());

						if (input.closest('input')) {
							input.type = field.type;
						}
					}

					input.name = field.name;
					input.required = field.required;

					if (field.type === 'file') {
						input.files = field.files;
					} else if (field.type === 'checkbox'){
						input.value = field.checked ? field.value : '';
					} else if (field.type === 'radio') {
						field.closest('form')
							.querySelectorAll(`input[type="radio"][name="${field.name}"]`)
							.forEach(radio => {
								if (radio.checked) {
									input.value = radio.value;
								}
							});
					} else {
						input.value = field.value;
					}

					input?.setAttribute('readonly', true);

					if (input) {
						hiddenFieldsContainer.append(input);
					}

                }

            }
        }

        to.append(hiddenFieldsContainer);
    }
}
